import { lazy, Suspense, useContext } from 'react'
import type { ComponentProps } from 'react'
import type NewsFeedComposerInner from '@/components/NewsFeedComposerInner'
import { WalletReadyContext } from '@/lib/walletContext'

/**
 * Client-only boundary for the News Feed composer.
 *
 * The inner composer uses wagmi `useWalletClient` so Post can open the connected
 * AppKit wallet sign modal. Loading it lazily keeps the Node prerender path
 * free of WalletConnect `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const NewsFeedComposerInnerLazy = lazy(() => import('@/components/NewsFeedComposerInner'))

type NewsFeedComposerProps = ComponentProps<typeof NewsFeedComposerInner>

function NewsFeedComposer(props: NewsFeedComposerProps) {
  const ready = useContext(WalletReadyContext)
  if (!ready) {
    return (
      <p className="rounded-2xl border border-white/10 bg-black/30 p-3 text-center text-xs text-zinc-500">
        Connect a wallet that holds this token to post an update.
      </p>
    )
  }

  return (
    <Suspense
      fallback={(
        <p className="rounded-2xl border border-white/10 bg-black/30 p-3 text-center text-xs text-zinc-500">
          Connect a wallet that holds this token to post an update.
        </p>
      )}
    >
      <NewsFeedComposerInnerLazy {...props} />
    </Suspense>
  )
}

export default NewsFeedComposer
